/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { entries, values, uniq } from 'lodash';

const getRulesFromColorMap = (colors: Object) =>
  entries(colors).map(([status, color]) => ({
    color,
    rule: { '==': [status, { var: 'label' }] },
  }));

export const MAPPED_COLORS = {
  Accepted: '#3bbf74',
  Accepting: '#58a5ec',
  Added: '#d7dce0',
  Assessed: '#9e5baa',
  Assigned: '#ffac1f',
  Avoided: '#3bbf74',
  Avoiding: '#58a5ec',
  Closed: '#343a40',
  Completed: '#3bbf74',
  Deprecated: '#343a40',
  Done: '#343a40',
  Draft: '#d7dce0',
  Effective: '#3bbf74',
  Final: '#3bbf74',
  High: '#ef4853',
  Identified: '#ef4853',
  Ineffective: '#ef4853',
  Launched: '#ffac1f',
  Low: '#3bbf74',
  Medium: '#ffac1f',
  Open: '#d7dce0',
  Rejected: '#343a40',
  Remediate: '#ef4853',
  Resolved: '#3bbf74',
  Reviewed: '#9e5baa',
  Sent: '#9e5baa',
  Submitted: '#ffac1f',
  Transferred: '#3bbf74',
  Transferring: '#58a5ec',
  Unfounded: '#8c641d',
  'Ignored/Invalid': '#343a40',
  'In progress': '#ffac1f',
  'In remediation': '#8c9ba5',
  'In Scope': '#ffac1f',
  'Not in Scope': '#ffac1f',
  'Not Launched': '#ffac1f',
  'Not set': '#8c9ba5',
  'Pending Assessment': '#ffac1f',
  'Remediation in progress': '#2e8fe7',
  'Under assessment': '#d18edd',
  'N/A': '#ced4da',
};

export const MAPPED_COLORS_FORMATTING_RULES = getRulesFromColorMap(MAPPED_COLORS);

export const COLORS_PALETTE = uniq(values(MAPPED_COLORS));
